import { css, useTheme } from '@emotion/react';
import styled from '@emotion/styled';
import React from 'react';

import { Box, Text } from '~/components/blocks';

type Props = {
  title: string;
};

const Root = styled(Box)(({ theme }) =>
  css({
    width: '100%',
    fontWeight: theme.fontWeights.bold,
    backgroundColor: theme.colors.background.default,
    textAlign: 'center',
    boxShadow: theme.shadows.default,
    position: 'fixed',
    zIndex: theme.zIndices.header,
  }),
);

export const Header = (props: Props) => {
  const theme = useTheme();
  const { title } = props;

  return (
    <Root>
      <Text size="l" lineHeight={theme.lineHeights.s} paddingY={theme.space.l}>
        {title}
      </Text>
    </Root>
  );
};
